var map = {
	"./common.json": [
		83147,
		83147
	],
	"./converter.json": [
		90509,
		90509
	],
	"./downloadHelpArticleModal.json": [
		34475,
		34475
	],
	"./fileTypes.json": [
		26638,
		26638
	],
	"./footer.json": [
		9170,
		9170
	],
	"./freeTrialModal.json": [
		27407,
		27407
	],
	"./inquiryForm.json": [
		11531,
		11531
	],
	"./landingPage.json": [
		75416,
		75416
	],
	"./navigation.json": [
		65619,
		65619
	],
	"./page/AIToFigma.json": [
		95060,
		95060
	],
	"./page/AIToSketch.json": [
		53974,
		53974
	],
	"./page/CanvaToAI.json": [
		95900,
		95900
	],
	"./page/CanvaToFigma.json": [
		41705,
		41705
	],
	"./page/CanvaToGoogleslides.json": [
		81321,
		81321
	],
	"./page/CanvaToHTML.json": [
		17216,
		17216
	],
	"./page/CanvaToIndesign.json": [
		6530,
		6530
	],
	"./page/CanvaToPSD.json": [
		32084,
		32084
	],
	"./page/CanvaToPowerpoint.json": [
		99713,
		99713
	],
	"./page/CanvaToWordpress.json": [
		95356,
		95356
	],
	"./page/CanvaToXd.json": [
		99872,
		99872
	],
	"./page/EPSToFigma.json": [
		60576,
		60576
	],
	"./page/ExpressToCanva.json": [
		40347,
		40347
	],
	"./page/ExpressToFigma.json": [
		534,
		534
	],
	"./page/ExtractImagesFromXD.json": [
		55762,
		55762
	],
	"./page/FigjamToLucidChart.json": [
		63304,
		63304
	],
	"./page/FigjamToMiro.json": [
		24929,
		24929
	],
	"./page/FigmaToAI.json": [
		79989,
		79989
	],
	"./page/FigmaToAfterEffects.json": [
		22835,
		22835
	],
	"./page/FigmaToAxure.json": [
		71050,
		71050
	],
	"./page/FigmaToBubble.json": [
		74420,
		74420
	],
	"./page/FigmaToCanva.json": [
		80833,
		80833
	],
	"./page/FigmaToGoogleSlides.json": [
		94217,
		94217
	],
	"./page/FigmaToIndesign.json": [
		50651,
		50651
	],
	"./page/FigmaToPDF.json": [
		41552,
		41552
	],
	"./page/FigmaToPSD.json": [
		73002,
		73002
	],
	"./page/FigmaToPowerpoint.json": [
		34467,
		34467
	],
	"./page/FigmaToSketch.json": [
		39950,
		39950
	],
	"./page/FigmaToWebflow.json": [
		41699,
		41699
	],
	"./page/FigmaToXD.json": [
		88241,
		88241
	],
	"./page/FreehandToFigjam.json": [
		62034,
		62034
	],
	"./page/GoogleSlidesToCanva.json": [
		28584,
		28584
	],
	"./page/GoogleSlidesToFigma.json": [
		64364,
		64364
	],
	"./page/IndesignToFigma.json": [
		5004,
		57082
	],
	"./page/IndesignToSketch.json": [
		12902,
		12902
	],
	"./page/IndesignToXd.json": [
		71123,
		71123
	],
	"./page/Inspector.json": [
		49317,
		49317
	],
	"./page/KeynoteToFigma.json": [
		9323,
		9323
	],
	"./page/KeynoteToSketch.json": [
		84188,
		84188
	],
	"./page/KeynoteToXd.json": [
		87032,
		87032
	],
	"./page/LucidChartToFigjam.json": [
		87391,
		87391
	],
	"./page/LucidChartToMiro.json": [
		32838,
		32838
	],
	"./page/MiroToFigjam.json": [
		19428,
		19428
	],
	"./page/MiroToLucidChart.json": [
		60676,
		60676
	],
	"./page/MiroToMural.json": [
		51406,
		51406
	],
	"./page/MuralToMiro.json": [
		91720,
		91720
	],
	"./page/PDFToAI.json": [
		93886,
		93886
	],
	"./page/PDFToFigma.json": [
		71405,
		71405
	],
	"./page/PDFToIndesign.json": [
		23182,
		23182
	],
	"./page/PDFToPSD.json": [
		61658,
		61658
	],
	"./page/PDFToSketch.json": [
		20852,
		20852
	],
	"./page/PDFToXD.json": [
		42247,
		42247
	],
	"./page/PSDToCanva.json": [
		20177,
		20177
	],
	"./page/PSDToFigma.json": [
		76098,
		76098
	],
	"./page/PSDToSketch.json": [
		88726,
		88726
	],
	"./page/PowerPointToAi.json": [
		1699,
		1699
	],
	"./page/PowerPointToCanva.json": [
		407,
		407
	],
	"./page/PowerPointToFigma.json": [
		18836,
		18836
	],
	"./page/PowerPointToPsd.json": [
		756,
		756
	],
	"./page/PowerPointToSketch.json": [
		52312,
		52312
	],
	"./page/PowerPointToXd.json": [
		71986,
		71986
	],
	"./page/SketchToAI.json": [
		57056,
		57056
	],
	"./page/SketchToFigma.json": [
		87120,
		87120
	],
	"./page/SketchToPSD.json": [
		78926,
		78926
	],
	"./page/SketchToXD.json": [
		16852,
		16852
	],
	"./page/VisioToFigjam.json": [
		20144,
		20144
	],
	"./page/WebsiteToFigma.json": [
		77032,
		77032
	],
	"./page/XDToAI.json": [
		67539,
		67539
	],
	"./page/XDToCanva.json": [
		45195,
		45195
	],
	"./page/XDToFigma.json": [
		14370,
		14370
	],
	"./page/XDToJPG.json": [
		45265,
		45265
	],
	"./page/XDToPDF.json": [
		7389,
		7389
	],
	"./page/XDToPSD.json": [
		9680,
		9680
	],
	"./page/XDToPowerpoint.json": [
		38721,
		38721
	],
	"./page/XDToSketch.json": [
		41924,
		41924
	],
	"./page/account.json": [
		19161,
		19161
	],
	"./page/airtable-backup.json": [
		83236,
		83236
	],
	"./page/canvaAuth.json": [
		79423,
		79423
	],
	"./page/converterFeatures.json": [
		15411,
		15411
	],
	"./page/enterprise.json": [
		26333,
		26333
	],
	"./page/figma-components-to-xd.json": [
		33358,
		33358
	],
	"./page/figma-design-backup.json": [
		3380,
		3380
	],
	"./page/filename.json": [
		77489,
		77489
	],
	"./page/files.json": [
		52447,
		52447
	],
	"./page/import-figma-in-canva.json": [
		84628,
		84628
	],
	"./page/legal.json": [
		79046,
		79046
	],
	"./page/miro-backup.json": [
		6455,
		6455
	],
	"./page/open-xd-file-flinto.json": [
		31250,
		31250
	],
	"./page/open-xd-file-old-corrupted.json": [
		60455,
		60455
	],
	"./page/open-xd-file-principle.json": [
		38044,
		38044
	],
	"./page/open-xd-in-builderx.json": [
		29545,
		29545
	],
	"./page/open-xd-in-uxpin.json": [
		23980,
		23980
	],
	"./page/pricing.json": [
		44726,
		44726
	],
	"./page/privacy.json": [
		87185,
		87185
	],
	"./page/refundPolicy.json": [
		28387,
		28387
	],
	"./page/settings.json": [
		73302,
		73302
	],
	"./page/solutionsForAgencies.json": [
		72008,
		72008
	],
	"./page/solutionsForEnterprise.json": [
		42434,
		42434
	],
	"./page/terms.json": [
		25091,
		25091
	],
	"./page/xd-components-to-figma.json": [
		44590,
		44590
	],
	"./payment.json": [
		6132,
		6132
	],
	"./section/airtableBackupFaq.json": [
		85094,
		85094
	],
	"./section/blog.json": [
		96112,
		96112
	],
	"./section/brokenXD.json": [
		23021,
		23021
	],
	"./section/colorfulCta.json": [
		39658,
		39658
	],
	"./section/contact.json": [
		23384,
		23384
	],
	"./section/conversion.json": [
		94808,
		94808
	],
	"./section/convertAllFormats.json": [
		43626,
		43626
	],
	"./section/convertEverything.json": [
		64929,
		64929
	],
	"./section/cta.json": [
		11380,
		11380
	],
	"./section/customersLogos.json": [
		15983,
		15983
	],
	"./section/description.json": [
		32429,
		32429
	],
	"./section/designEngine.json": [
		99087,
		99087
	],
	"./section/enterpriseSolutionsFaq.json": [
		87960,
		87960
	],
	"./section/faq.json": [
		68532,
		68532
	],
	"./section/features.json": [
		95070,
		95070
	],
	"./section/featuresSimple.json": [
		6948,
		6948
	],
	"./section/figmaBackupFaq.json": [
		13323,
		13323
	],
	"./section/getStartedVideo.json": [
		8193,
		8193
	],
	"./section/magicians.json": [
		24691,
		24691
	],
	"./section/newsletterSignup.json": [
		24657,
		24657
	],
	"./section/pricing.json": [
		71572,
		71572
	],
	"./section/pricingFigmaBackup.json": [
		63246,
		63246
	],
	"./section/requestDemo.json": [
		93955,
		93955
	],
	"./section/selectFormat.json": [
		88681,
		88681
	],
	"./section/testimonials.json": [
		88610,
		88610
	],
	"./section/trustedBy.json": [
		53638,
		53638
	],
	"./successfulPaymentModal.json": [
		67475,
		67475
	],
	"./welcomeAboardModal.json": [
		88076,
		88076
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 73231;
module.exports = webpackAsyncContext;